import React, { FC } from 'react'

import clsx from 'clsx'
import { v4 as uuidv4 } from 'uuid'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form/dist/types/form'

import SwitchElement from '../../../../elements/toggles/toggles/SwitchElement'

import { IScoreCardInterface } from '../../../../../models/score-cards/score-cards.interface'

import { INITIAL_ROW, INITIAL_SECTION } from '../../../../../const/score-card-const'

interface JumpOffToggleProps {
  setValue: UseFormSetValue<IScoreCardInterface>
  watch: UseFormWatch<IScoreCardInterface>
  hideTitle?: boolean
  className?: string
  editable: boolean
}
export const JumpOffToggle: FC<JumpOffToggleProps> = ({
  watch,
  setValue,
  className,
  hideTitle,
  editable,
}) => {
  const onShowTotalSection = () => {
    const existTotalSection = watch('sections').filter((section) => section.type === 'jump off')

    setValue(`showJumpOff`, !watch(`showJumpOff`))

    if (watch(`showJumpOff`) && existTotalSection.length <= 0) {
      setValue('sections', [
        ...watch('sections'),
        {
          id: uuidv4(),
          name: 'Jump Off',
          type: 'jump off',
          ...INITIAL_SECTION,
          rows: [{ id: uuidv4(), ...INITIAL_ROW }],
        },
      ])
    }
  }

  return (
    <div className={clsx('flex items-center gap-2 text-[14px] whitespace-nowrap', className)}>
      {!hideTitle && 'Jump off'}
      <SwitchElement
        disabled={!editable}
        buttonClassName="small"
        on={watch('showJumpOff')}
        onSwitch={() => editable && onShowTotalSection()}
      />
    </div>
  )
}
